import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../UI/Icon';
import './ProgramsTeaser.css';

import { IconName } from '../UI/Icon';

type Program = {
  icon: IconName;
  title: string;
  description: string;
  link: string;
};



const ProgramsTeaser: React.FC = () => {
  const programs: Program[] = [
    {
      icon: 'FaUtensils',
      title: 'Community Nutritional Development Project (CNDC)',
      description: 'This program is dedicated to fighting hunger by providing vulnerable community members with nutritious meals. It also serves as a gateway to sustainable poverty alleviation by connecting beneficiaries with government services and skills training.',
      link: '/programs'
    },
    {
      icon: 'FaBriefcase',
      title: 'EPWP Program',
      description: 'We collaborate with the government\'s Public Employment Programme to create temporary to long-term work opportunities, aiming to reduce poverty and unemployment in the community.',
      link: '/programs'
    },
    {
      icon: 'FaFemale',
      title: 'Advocacy against Gender-Based Violence',
      description: 'This program advocates for the rights and safety of women and children affected by gender-based violence. We raise awareness, provide support to survivors through counseling and training, and lobby for policy changes to foster a culture of respect and empathy.',
      link: '/programs'
    },
    {
      icon: 'FaUserFriends',
      title: 'Senior Citizens Programs',
      description: 'Our programs are designed to support the physical, emotional, and social well-being of senior citizens. We offer social support, health and wellness activities, and educational programs to promote independence and a sense of community.',
      link: '/programs'
    },
    {
      icon: 'FaHeartbeat',
      title: 'Alcohol Abuse Prevention Programs',
      description: 'This program provides comprehensive services to prevent and address alcohol abuse. We offer education, counseling, support groups, and community outreach to promote healthy lifestyles and support individuals in their recovery journey.',
      link: '/programs'
    }
  ];

  return (
    <section className="programs-teaser-section">
      <div className="programs-teaser-container">
        <div className="programs-teaser-wrapper">
          <div className="programs-teaser-grid">
            {programs.map((program, index) => (
              <div key={index} className="program-teaser-card">
                <div className="program-teaser-icon">
                  <Icon name={program.icon} className="program-icon" />
                </div>
                <h3 className="program-teaser-title">{program.title}</h3>
                <p className="program-teaser-description">{program.description}</p>
                <Link to={program.link} className="program-teaser-link" onClick={() => window.scrollTo(0, 0)}>
                  Learn More <Icon name="FaArrowRight" className="program-teaser-arrow" />
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProgramsTeaser;
